/* firmanumre-nav.js - "Find efter mønster": preview-felt og fremhaevning.
   Dataene (eksempler, regel, antal, laveste pris) ligger som
   data-attributter paa linkene, renderet af snippets/fn-nav-panel.liquid.
   Reglerne er beskrevet i samme snippet. Mobilskuffen faar ét eksempel
   under hvert link ud fra de samme data. */
(function () {
  'use strict';
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function kr(n) { return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',-'; }

  /* Returnerer et saet af cifferpositioner (0-7), der skal fremhaeves. */
  function positioner(visning, regel) {
    var d = visning.replace(/\D/g, ''), s = {}, i, j;
    function mark(a, b) { for (var k = a; k < b; k++) s[k] = 1; }
    function par(i) { return d.substr(i, 2); }
    if (!regel || d.length < 4) return s;
    if (regel === 'par') {
      var antal = {}; for (i = 0; i < 8; i += 2) antal[par(i)] = (antal[par(i)] || 0) + 1;
      for (i = 0; i < 8; i += 2) if (antal[par(i)] >= 2) mark(i, i + 2);
    } else if (regel === 'par2') {
      for (i = 0; i < 8; i += 2) if (d[i] === d[i + 1]) mark(i, i + 2);
    } else if (regel === 'ens3' || regel === 'ens4') {
      var min = regel === 'ens3' ? 3 : 4, bedst = null;
      i = 0;
      while (i < d.length) { j = i; while (j < d.length && d[j] === d[i]) j++; if (j - i >= min) { if (regel === 'ens3') mark(i, j); else if (!bedst || j - i > bedst[1] - bedst[0]) bedst = [i, j]; } i = j; }
      if (bedst) mark(bedst[0], bedst[1]);
    } else if (regel === 'abc') {
      /* Foerst visningens egne blokke ("22 722 722" -> 722 og 722), ellers
         den foerste gentagne blok paa tre cifre. */
      var g3 = visning.split(' '), p3 = 0, fundet = false;
      for (i = 0; i < g3.length && !fundet; i++) { for (j = i + 1; j < g3.length; j++) if (g3[i].length === 3 && g3[i] === g3[j]) { var pa = 0, pb = 0, k2; for (k2 = 0; k2 < i; k2++) pa += g3[k2].length; for (k2 = 0; k2 < j; k2++) pb += g3[k2].length; mark(pa, pa + 3); mark(pb, pb + 3); fundet = true; break; } }
      if (!fundet) for (i = 0; i <= 2; i++) { var blok = d.substr(i, 3); j = d.indexOf(blok, i + 3); if (j !== -1) { mark(i, i + 3); mark(j, j + 3); break; } }
    } else if (regel === 'ti') {
      for (i = 0; i < 8; i += 2) if (d[i + 1] === '0') mark(i, i + 2);
    } else if (regel === 'hundrede') {
      /* blokkene i visningen: "93 100 700" -> 100 og 700 */
      var g = visning.split(' '), pos = 0;
      for (i = 0; i < g.length; i++) { if (g[i].length === 3 && /00$/.test(g[i])) mark(pos, pos + 3); pos += g[i].length; }
      if (!Object.keys(s).length) for (i = 0; i <= 5; i++) if (d.substr(i + 1, 2) === '00') { mark(i, i + 3); i += 2; }
    } else if (regel === 'tusind') {
      for (i = 0; i <= 4; i++) if (d.substr(i + 1, 3) === '000') { mark(i, i + 4); break; }
    } else if (regel === 'system') {
      var g2 = visning.split(' '), tal = g2.map(Number), bedstG = null, start = 0, k;
      for (i = 0; i < tal.length; i++) {
        for (j = tal.length; j - i >= 3; j--) {
          var diff = tal[i + 1] - tal[i], ok = diff !== 0;
          for (k = i + 1; k < j && ok; k++) if (tal[k] - tal[k - 1] !== diff) ok = false;
          if (ok && (!bedstG || j - i > bedstG[1] - bedstG[0])) { bedstG = [i, j]; }
        }
      }
      if (bedstG) { var p0 = 0; for (i = 0; i < bedstG[0]; i++) p0 += g2[i].length; var p1 = p0; for (i = bedstG[0]; i < bedstG[1]; i++) p1 += g2[i].length; mark(p0, p1); }
      else {
        var bedstD = null;
        for (i = 0; i < d.length; i++) for (j = d.length; j - i >= 4; j--) { var df = d.charCodeAt(i + 1) - d.charCodeAt(i), ok2 = Math.abs(df) === 1; for (k = i + 1; k < j && ok2; k++) if (d.charCodeAt(k) - d.charCodeAt(k - 1) !== df) ok2 = false; if (ok2 && (!bedstD || j - i > bedstD[1] - bedstD[0])) bedstD = [i, j]; }
        if (bedstD) mark(bedstD[0], bedstD[1]);
      }
    } else if (regel === '70') {
      mark(0, 2);
    } else if (regel === 'blok4') {
      /* 2 x abcd: to firecifrede blokke - begge fremhaeves */
      mark(0, 8);
    } else if (regel === 'aaa100') {
      i = 0; while (i < d.length) { j = i; while (j < d.length && d[j] === d[i]) j++; if (j - i >= 3) mark(i, j); i = j; }
      for (i = 0; i <= 5; i++) if (d.substr(i + 1, 2) === '00' && !s[i]) { mark(i, i + 3); break; }
    } else if (regel === 'nuller') {
      mark(4, 8);
    }
    return s;
  }

  /* Visningen med de fremhaevede cifre pakket i <em class="fn-hl">. */
  function fremhaev(visning, regel) {
    var s = positioner(visning, regel), ud = '', k = 0, aaben = false;
    for (var i = 0; i < visning.length; i++) {
      var c = visning.charAt(i), erTal = c >= '0' && c <= '9';
      var hl = erTal && s[k];
      /* Luk fremhaevningen ved mellemrum, saa stregen kun ligger under cifrene og ikke fylder
         mellemrummene mellem grupperne (Richard 07.09.2026). Aabnes igen ved naeste ciffer. */
      if (!hl && aaben) { ud += '</em>'; aaben = false; }
      if (hl && !aaben) { ud += '<em class="fn-hl">'; aaben = true; }
      ud += esc(c);
      if (erTal) k++;
    }
    if (aaben) ud += '</em>';
    return ud;
  }

  function opsaetPanel(panel) {
    var pv = panel.querySelector('[data-fn-nav-preview]'); if (!pv) return;
    var titel = pv.querySelector('[data-pv-titel]'), besk = pv.querySelector('[data-pv-besk]'), pris = pv.querySelector('[data-pv-pris]'), rul = pv.querySelector('[data-pv-rul]');
    var slots = pv.querySelectorAll('.fn-nav__pv-slot');
    var links = panel.querySelectorAll('[data-fn-nav-link]');
    function vis(a) {
      var eks = (a.getAttribute('data-eks') || '').split('|').filter(Boolean), regel = a.getAttribute('data-regel') || '';
      titel.textContent = a.getAttribute('data-titel') || '';
      besk.textContent = a.getAttribute('data-besk') || '';
      for (var i = 0; i < slots.length; i++) {
        var tal = slots[i].querySelector('.fn-nrkort__tal');
        if (eks[i]) { tal.innerHTML = fremhaev(eks[i], regel); slots[i].hidden = false; slots[i].href = a.getAttribute('href'); }
        else { tal.innerHTML = ''; slots[i].hidden = true; }
      }
      if (rul) rul.scrollTop = 0;
      var antal = parseInt(a.getAttribute('data-antal') || '0', 10), min = parseFloat(a.getAttribute('data-min') || '0');
      pris.textContent = antal ? (antal >= 50 ? '50+ ledige' : antal + (antal === 1 ? ' ledigt' : ' ledige')) + (min ? ' · fra ' + kr(min) : '') : '';
      for (var j = 0; j < links.length; j++) links[j].classList.toggle('fn-nav__link--aktiv', links[j] === a);
    }
    for (var i = 0; i < links.length; i++) {
      links[i].addEventListener('mouseenter', function () { vis(this); });
      links[i].addEventListener('focus', function () { vis(this); });
    }
    if (links.length) vis(links[0]);

    /* Aabning og lukning styres her, ikke af :hover alene: panelet bliver
       staaende 350 ms efter, at musen har forladt det, saa et skraat traek
       hen over de andre menupunkter ikke lukker det. Pilen oeverst peger
       paa knappen. */
    var punkt = panel.closest('.fn-nav__punkt'), knap = punkt ? punkt.querySelector('.fn-nav__knap') : null, pil = panel.querySelector('[data-fn-nav-pil]'), timer = null;
    function placerPil() { if (!pil || !knap) return; var k = knap.getBoundingClientRect(), p = panel.getBoundingClientRect(); pil.style.left = Math.round(k.left + k.width / 2 - p.left) + 'px'; }
    function aabn() { if (timer) { window.clearTimeout(timer); timer = null; } if (!punkt.classList.contains('fn-nav__punkt--aaben')) { punkt.classList.add('fn-nav__punkt--aaben'); knap && knap.setAttribute('aria-expanded', 'true'); window.requestAnimationFrame(placerPil); } }
    function lukSenere() { if (timer) window.clearTimeout(timer); timer = window.setTimeout(function () { punkt.classList.remove('fn-nav__punkt--aaben'); knap && knap.setAttribute('aria-expanded', 'false'); }, 350); }
    if (punkt) {
      punkt.addEventListener('mouseenter', aabn);
      punkt.addEventListener('mouseleave', lukSenere);
      punkt.addEventListener('focusin', aabn);
      punkt.addEventListener('focusout', function (e) { if (!punkt.contains(e.relatedTarget)) lukSenere(); });
      if (knap) knap.addEventListener('click', function () { if (punkt.classList.contains('fn-nav__punkt--aaben')) { punkt.classList.remove('fn-nav__punkt--aaben'); knap.setAttribute('aria-expanded', 'false'); } else aabn(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { punkt.classList.remove('fn-nav__punkt--aaben'); knap && knap.setAttribute('aria-expanded', 'false'); } });
      window.addEventListener('resize', placerPil);
    }
  }

  /* Mobilskuffen: ét eksempel under hvert link, farvet efter samme regel. */
  function opsaetSkuffe(panel) {
    var kort = {};
    panel.querySelectorAll('[data-fn-nav-link]').forEach(function (a) { kort[a.getAttribute('href')] = a; });
    document.querySelectorAll('#NavDrawer a.mobile-nav__link').forEach(function (a) {
      if (a.closest('.mobile-nav__has-sublist')) return; /* forældrepunktet har selv en undermenu - et eksempel der ville gentage "Alle numre"s */
      var kilde = kort[a.getAttribute('href')]; if (!kilde || a.querySelector('.fn-nav__eks')) return;
      var eks = (kilde.getAttribute('data-eks') || '').split('|').filter(Boolean); if (!eks.length) return;
      var span = document.createElement('span'); span.className = 'fn-nav__eks'; span.setAttribute('aria-hidden', 'true');
      span.innerHTML = fremhaev(eks[0], kilde.getAttribute('data-regel') || '') + (eks[1] ? ' · ' + fremhaev(eks[1], kilde.getAttribute('data-regel') || '') : '');
      a.appendChild(span);
    });
  }

  function start() {
    var panel = document.querySelector('[data-fn-nav-panel]'); if (!panel) return;
    opsaetPanel(panel); opsaetSkuffe(panel);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  window.fnNav = { positioner: positioner, fremhaev: fremhaev };
})();
